import type { TechnologyItem } from "app/pages/workspace/sales/sub-modules/feed/types/technologies";

import type { JSX } from "react";

export type SortableField =
    | "category"
    | "subCategory"
    | "technologyName"
    | "isFree"
    | "isPaid"
    | "workingPeriod"
    | "status"
    | "removedPeriod";

export type SortDirection = "asc" | "desc";

export type SortSettingsType = Record<SortableField, SortDirection>;

export type CategoryFilterProps = {
    onSelect: (category: unknown) => void;
    category: string;
    rawData?: TechnologyItem[];
    onClear: () => void;
    appendTo?: string;
};
export type SubDomainFilterProps = {
    onSelect: (subdomains: string[]) => void;
    data?: { share: string; number?: number } | Record<string, number>;
    activeWebsite?: string;
    clearOnActiveWebsiteChange?: boolean;
    disabled: boolean;
    onClear: () => void;
    appendTo?: string;
    headerComponent?: React.ReactElement | JSX.Element;
};

export type SearchTechnologyProps = {
    value: string;
    isDisabled?: boolean;
    onSearch: (searchElement: { target: { value: string } }) => void;
    excelUrl: string;
};

export enum StatusFilterValue {
    InstalledAndRemoved = "installedAndRemoved",
    Installed = "installed",
    Removed = "removed",
}
